import { useState } from "react";
import { useAuth } from "../hooks/useAuth";

export const ImpersonationControl = () => {
  const { impersonate, stopImpersonating, isImpersonating, user } = useAuth();
  const [targetUserId, setTargetUserId] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [loading, setLoading] = useState(false);

  // Only show for user ID 555
  if (user?.ID !== 555) return null;

  const handleImpersonate = async () => {
    if (!targetUserId) return;
    setLoading(true);
    const success = await impersonate(Number(targetUserId));
    if (success) {
      setTargetUserId("");
      setShowInput(false);
    }
    setLoading(false);
  };

  const handleStopImpersonating = () => {
    stopImpersonating();
  };

  const isCurrentlyImpersonating = isImpersonating();

  return {
    isCurrentlyImpersonating,
    showInput,
    setShowInput,
    targetUserId,
    setTargetUserId,
    loading,
    handleImpersonate,
    handleStopImpersonating,
  };
};
